module.exports = __webpack_public_path__ + "static/media/screenshot5.ba729454.png";